import { TableCell, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import type { SxProps } from "@mui/material";
import type { ReactNode } from "react";

function ArticleLineHeader(): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const bodyVariant: { variant: "body1" | "body2" } = {
    variant: isSmallScreen ? "body2" : "body1",
  };

  const padding05: { sx: SxProps } = {
    sx: { paddingX: 0.5, paddingY: 1, verticalAlign: "top" },
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell {...padding05}>
          <Typography {...bodyVariant} sx={{ fontWeight: 600 }}>
            Qté
          </Typography>
        </TableCell>
        <TableCell {...padding05}>
          <Typography {...bodyVariant} sx={{ fontWeight: 600 }}>
            Article
          </Typography>
        </TableCell>
        <TableCell {...padding05} align="right">
          <Typography {...bodyVariant} sx={{ fontWeight: 600 }}>
            Taille
          </Typography>
        </TableCell>
        <TableCell align="right" sx={{ paddingX: 0.5 }}>
          <Typography {...bodyVariant} sx={{ fontWeight: 600 }}>
            État
          </Typography>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default ArticleLineHeader;
